import { useSnapshot } from 'valtio';

import { HelpMenu } from 'components/StudioLayout';
import { LoadingTimeline, Timeline } from 'components/Timeline';
import { animationPlayerStore, projectStore, userStore } from 'stores';

import MainPlayerControlsNew from './MainPlayerControlsNew';
import { MobilePlaybackSpeed, PlaybackSettings } from './PlaybackSettings';

export default function AnimationFooter() {
  const { currentProject, motion } = useSnapshot(projectStore.state);
  const { userInfo } = useSnapshot(userStore.state);
  const playerStore = animationPlayerStore.defaultInstance;
  const isUserOwned = userInfo?.userID === currentProject.data?.createdBy;
  const hasTimeline =
    Object.values(currentProject.data?.characters ?? {})[0]?.timeline.length >
    0;
  const hasTimelineItems = Object.values(motion.timelineData ?? {}).length > 0;
  return (
    <div>
      {isUserOwned && hasTimeline && (
        <div className="relative z-0 flex flex-none flex-col justify-end pt-5">
          {hasTimelineItems ? <Timeline /> : <LoadingTimeline />}
        </div>
      )}
      <div className="flex h-[64px] flex-none pr-2 lg:pr-0">
        <div className="flex-1">{hasTimelineItems && <PlaybackSettings />}</div>
        {hasTimelineItems && (
          <MainPlayerControlsNew animationPlayerStore={playerStore} />
        )}
        <div className="flex flex-1 items-center justify-end">
          <HelpMenu />
          <MobilePlaybackSpeed />
        </div>
      </div>
    </div>
  );
}
